import { fetch } from '@/plugin/axios/index.js'

/**
 * @param {Object} data
 * 获取故障原因列表
 */
export function getFaultReasonList(data) {
  return fetch ({
    url: '/repair/repair/faultReason/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 保存故障原因
 */
export function saveFaultReason(data) {
  return fetch({
    url: '/repair/repair/faultReason/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除故障原因
 */
export function deleteCause(data) {
  return fetch({
    url: '/repair/repair/faultReason/delete',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/FaultCause/index.js